<div class="lpa-matriculas">
<app-page-header
  [title]="'Vinculaciones'"
  [subtitle]="'Módulo de gestión vinculaciones'"
  [icon]="'pi pi-id-card'"
></app-page-header>
<p-toast ></p-toast>

<p-inplace [closable]="true" [active]="searchNewMember" (onActivate)="newMemberSearch()" >
    <ng-template pTemplate="display">
        <p-button label="Buscar Vinculación" [rounded]="true" class="btn-vinculaciones" size="small"></p-button>
    </ng-template>
    <ng-template pTemplate="closeicon" class="btn-buscar">
        <i class="pi pi-sort-up" style="font-size: 1rem"></i>
    </ng-template>
    <ng-template pTemplate="content">

        <div class="surface-section px-2 py-2 md:px-4 lg:px-6 text-center">
            <div class="mb-3 font-bold text-2xl">
                <span class="text-900">Consultar, </span>
                <span class="text-primary-600">Vinculación</span>
            </div>
            <div class="text-700 mb-6">Ingresa la información de la identificación del miembro.</div>
            <div class="search-inputs">
                <p-dropdown
                  class="m-2 w-2 text-left"
                  [options]="idTypes"
                  [(ngModel)]="idTypeSelected"
                  optionLabel="name"
                  optionValue="value"
                  placeholder="Seleccione tipo de identificación"
                ></p-dropdown>
                <p-inputNumber
                class="m-2"
                  [(ngModel)]="idNumberSelected"
                  mode="decimal"
                  inputId="withoutgrouping"
                  [useGrouping]="false"
                  placeholder="numero de identificación"
                  [allowEmpty]="true"
                  (keydown.enter)="searchMemberById()"
                  autocomplete="off"
                >
                </p-inputNumber>
                <button
                  type="button"
                  pButton
                  icon="pi pi-search"
                  class="m-2 p-button-primary"
                  (click)="searchMemberById()"
                ></button>
              </div>
        </div>
    </ng-template>
</p-inplace>

<p-divider></p-divider>

<div *ngIf="showNoFindedMember">
    <p-dialog  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" 
    [style]="{ width: '50vw' }"  [modal]="true" [(visible)]="showNoFindedMember"> 
        <p-card  header="Sin Coincidencia" subheader="No hemos encontrado la vinculación" [style]="{'text-align':'center', border: 'none'}">
            <ng-template pTemplate="header">
                <div class="flex justify-content-center m-2">
                    <i class="pi pi-exclamation-circle" style="font-size: 4rem"></i>
                </div>
            </ng-template>
            <p [style]="{'text-align':'justify'}">
                No hemos encontrado información para el miembro identificado con {{idTypeSelected}}{{idNumberSelected}}, por favor verifica la información.
            </p>
            <p [style]="{'text-align':'justify'}">
                Si es nuevo miembro, realiza su vinculación haciendo clic en el botón "Nueva Vinculación".
            </p>
            <ng-template pTemplate="footer">
                <p-button label="Nueva Vinculación" icon="pi pi-plus" (click)="initMemberRegister()"></p-button>
            </ng-template>
        </p-card>

    </p-dialog>

</div>

<div *ngIf="showMemberMenu" class="member-menu">
    <app-member-menu [member]="memberSelected"></app-member-menu>
</div>  

<div *ngIf="showMemberRegister" class="member-menu">
    <app-member-register [clubes]="clubes" [idNumber]="idNumberSelected" [idType]="idTypeSelected" (memberCreated)="refreshMemberCreated($event)"></app-member-register>
</div>
</div>
